import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";

export default function StaffClients() {
  const [clients, setClients] = useState([]);
  const [cases, setCases] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/staff/clients").then((r) => setClients(r.data)).catch(() => {});
    api.get("/cases").then((r) => setCases(r.data)).catch(() => {});
  }, []);

  const filtered = clients.filter((c) =>
    !query || c.name?.toLowerCase().includes(query.toLowerCase()) || c.email?.toLowerCase().includes(query.toLowerCase())
  );

  const firstCaseFor = (uid) => cases.find((c) => c.client_id === uid);

  return (
    <div className="space-y-6" data-testid="staff-clients-page">
      <div>
        <h1 className="text-2xl font-serif font-semibold text-navy tracking-tight">Clients</h1>
        <p className="mt-1 text-sm text-mutedink">Every person with a Full Circle portal account.</p>
      </div>

      <div className="relative max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-mutedink" />
        <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search clients..." className="pl-9 rounded-full bg-surface" data-testid="clients-search" />
      </div>

      <div className="bg-surface border border-line rounded-2xl shadow-sm overflow-hidden" data-testid="clients-table">
        {filtered.length === 0 ? (
          <p className="text-sm text-mutedink p-8 text-center">No client accounts yet. Clients appear here after they create their portal account.</p>
        ) : (
          <div className="divide-y divide-line">
            {filtered.map((c) => {
              const firstCase = firstCaseFor(c.user_id);
              return (
                <div key={c.user_id} className="p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`client-row-${c.user_id}`}>
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    {c.picture ? (
                      <img src={c.picture} alt="" className="h-9 w-9 rounded-full border border-line" referrerPolicy="no-referrer" />
                    ) : (
                      <div className="h-9 w-9 rounded-full bg-teal-light flex items-center justify-center text-teal text-sm font-semibold">{c.name?.[0] || "?"}</div>
                    )}
                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-navy truncate">{c.name}</p>
                      <p className="text-xs text-mutedink truncate">{c.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-xs text-mutedink">Journey step {(c.journey_step ?? 0) + 1} of 9</span>
                    {firstCase ? (
                      <Link to={`/staff/cases/${firstCase.case_id}`} className="text-xs font-semibold text-teal hover:underline" data-testid={`client-case-link-${c.user_id}`}>
                        Open case
                      </Link>
                    ) : (
                      <span className="text-xs text-mutedink">No case yet</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
